<template>
	<div>
		<b-modal
			ref="padrillos-posture-modal"
			:title="'PADRILLOS'"
			centered
			v-model="isActive"
			@hidden="handleHidden"
			size="xlg"
			hide-footer
		>
			<b-overlay :show="isLoading">
				<b-row class="mb-1">
					<b-col class="d-flex align-items-center">
						<b-tabs v-model="indexTab">
							<b-tab :disabled="false">
								<template #title>
									Programados
									<b-badge class="ml-1" variant="primary" v-if="counters.programados > 0">
										{{ counters.programados }}
									</b-badge>
								</template>
							</b-tab>
							<b-tab :disabled="false">
								<template #title>
									No programados
									<b-badge class="ml-1" variant="primary" v-if="counters.no_programados > 0">
										{{ counters.no_programados }}
									</b-badge>
								</template>
							</b-tab>
							<b-tab :disabled="false">
								<template #title>
									Disponibles
									<b-badge class="ml-1" variant="primary" v-if="counters.availables > 0">
										{{ counters.availables }}
									</b-badge>
								</template>
							</b-tab>
						</b-tabs>
					</b-col>
				</b-row>

				<b-card v-if="indexTab === 0">
					<b-row>
						<b-col class="d-flex align-items-center">
							<b-tabs v-model="indexSubTab">
								<b-tab :disabled="false">
									<template #title>Inseminados</template>
								</b-tab>
								<b-tab :disabled="false">
									<template #title>Por inseminar</template>
								</b-tab>
							</b-tabs>
						</b-col>
					</b-row>
				</b-card>
				<b-table-simple v-if="[0, 1].includes(indexTab)" responsive sticky-header="60vh" no-border-collapse>
					<b-thead class="sticky-header">
						<b-th class="text-center">Padrillo</b-th>
						<b-th class="text-center">Nº Madrillas</b-th>
						<b-th v-if="(indexTab === 0 && indexSubTab === 1) || indexTab === 1" class="text-center">
							Acciones
						</b-th>
					</b-thead>
					<b-tbody>
						<template v-for="(data, index) in specimens">
							<b-tr :key="index">
								<b-td class="text-center">
									<div
										style="
											display: flex;
											gap: 1rem;
											align-items: flex-start;
											justify-content: center;
										"
									>
										<v-icon
											v-if="data.inseminateds > 0 && indexSubTab === 1"
											name="gi-eyedropper"
											scale="1.2"
											class="text-primary"
											v-b-tooltip.hover.bottom="'Ya tuvo una inseminación'"
										/>

										<div class="d-flex flex-column gap-y-1">
											<SpecimenPlate :specimen="data" />
											<PeriodDays :padrillo="data" />
										</div>
									</div>
								</b-td>

								<b-td class="text-center">
									<h4>
										<b-badge
											variant="light-primary"
											class="cursor-pointer"
											@click="showModalMadrillas(data)"
										>
											{{ data.posturas }}
										</b-badge>
									</h4>
								</b-td>

								<b-td
									v-if="(indexTab === 0 && indexSubTab === 1) || indexTab === 1"
									class="text-center"
								>
									<div class="d-flex justify-content-center">
										<b-button
											class="btn-sm"
											variant="outline-primary"
											@click="openModalPosturaPad(data)"
										>
											<FeatherIcon icon="PlusIcon" size="20" />
										</b-button>
									</div>
								</b-td>
							</b-tr>
						</template>
						<b-tr v-if="specimens.length == 0">
							<b-td colspan="10" class="text-center" style="height: 80px">
								No hay registros para mostrar
							</b-td>
						</b-tr>
					</b-tbody>
				</b-table-simple>

				<div v-if="indexTab === 2">
					<b-row class="mt-2">
						<b-col cols="0" xl="6"></b-col>
						<b-col cols="12" xl="6" class="d-flex" style="gap: 12px">
							<b-input-group>
								<b-input-group-prepend>
									<b-button class="btn-icon" variant="outline-secondary" disabled>
										<feather-icon icon="SearchIcon" />
									</b-button>
								</b-input-group-prepend>
								<b-form-input
									placeholder="Buscar placa o alias..."
									v-model="searchFilter"
									@keypress.enter="fetchSpecimensWithoutPostures"
								/>
							</b-input-group>
							<div class="d-flex" style="gap: 8px">
								<b-button variant="outline-primary" @click="fetchSpecimensWithoutPostures">
									Buscar
								</b-button>
								<b-button class="btn-icon" variant="outline-secondary">
									<feather-icon icon="RefreshCcwIcon" @click="clearFilters" />
								</b-button>
							</div>
						</b-col>
					</b-row>
					<b-table-simple responsive sticky-header="60vh" class="cst-table mt-2" v-if="!dispuestosLoading">
						<b-thead class="cst-head text-nowrap text-center">
							<b-tr>
								<b-th class="bg-white border-0"></b-th>
								<b-th class="bg-primary text-white roundedTop" colspan="3">Descanso</b-th>
								<b-th class="bg-white border-0"></b-th>
							</b-tr>
							<b-tr class="text-center">
								<b-th class="text-center px-2 align-middle">Padrillo</b-th>
								<!--  -->
								<b-th class="text-center px-2 align-middle">Inicio</b-th>
								<b-th class="text-center px-2 align-middle">Tiempo en descanso</b-th>
								<b-th class="text-center px-2 align-middle">Enviado por</b-th>
								<b-th class="text-center px-2 align-middle">Tracking</b-th>
								<b-th class="text-center px-2 align-middle">Acciones</b-th>
							</b-tr>
						</b-thead>
						<TransitionGroup tag="tbody" role="table">
							<b-tr class="text-center row-table-posture" v-for="posture in postures" :key="posture.id">
								<b-th class="text-center py-50 px-2">
									<div class="d-flex flex-column gap-y-1">
										<SpecimenPlate
											:specimen="{
												id: posture.specimen.id,
												plate: posture.specimen.plate,
												alias: posture.specimen.alias,
												thumb: posture.specimen.thumb,
												image: posture.specimen.url,
											}"
										/>
										<PeriodDays
											:padrillo="{
												id: posture.specimen.id,
												period_start: posture.specimen.period_start,
											}"
										/>
									</div>
								</b-th>
								<b-th>
									<span v-if="posture.start_date">
										{{ posture.start_date | myGlobalDayShort }}
									</span>
									<span v-else>---</span>
								</b-th>
								<b-th>
									<span v-if="posture.days_in_rest != null">{{ posture.days_in_rest }} dia(s)</span>
									<span v-else>---</span>
								</b-th>
								<b-th>
									<span v-if="posture.created_by">{{ posture.created_by }}</span>
									<span v-else>---</span>
								</b-th>
								<b-th>
									<div class="d-flex justify-content-center gap-x-2">
										<feather-icon
											v-b-tooltip.hover
											title="Tracking"
											icon="ListIcon"
											size="24"
											class="cursor-pointer text-primary"
											@click="
												;(padrilloAvailable.info = posture),
													(padrilloAvailable.show = !padrilloAvailable.show)
											"
										/>
									</div>
								</b-th>
								<b-td class="text-center">
									<div class="d-flex justify-content-center">
										<b-button
											class="btn-sm"
											variant="outline-primary"
											@click="openModalPosturaPad(posture.specimen)"
											v-b-tooltip.hover.top="'Agregar Postura'"
										>
											<FeatherIcon icon="PlusIcon" size="20" />
										</b-button>
									</div>
								</b-td>
							</b-tr>
						</TransitionGroup>
					</b-table-simple>
					<div v-else class="mt-2">
						<b-skeleton-table :rows="8" :columns="3" :table-props="{ bordered: true, striped: true }" />
					</div>
					<p class="text-center p-3" v-if="postures.length === 0">No hay registros para mostrar</p>
					<b-row class="mt-2">
						<b-col cols="6" class="d-flex align-items-center pagination-label">
							<p style="margin: 0 0 0 1.2rem">
								Mostrando {{ this.from }} a {{ this.to }} de {{ this.total }} ejemplares disponibles
							</p>
						</b-col>
						<b-col cols="6" class="d-flex justify-content-end">
							<b-pagination
								@input="fetchSpecimensWithoutPostures"
								v-model="currentPage"
								:total-rows="total"
								:per-page="20"
								first-number
								last-number
								align="right"
								class="mb-0 mt-1 mt-sm-0"
								prev-class="prev-item"
								next-class="next-item"
							>
								<template #prev-text>
									<feather-icon icon="ChevronLeftIcon" size="18" />
								</template>
								<template #next-text>
									<feather-icon icon="ChevronRightIcon" size="18" />
								</template>
							</b-pagination>
						</b-col>
					</b-row>
				</div>
			</b-overlay>

			<MadrillasWithInseminationPending
				v-if="showMadrillasModal"
				:show="showMadrillasModal"
				:info="infoPadrillo"
				@close="showMadrillasModal = false"
			/>

			<AddPosturaWithPadrillo
				v-if="openModalPosturaPadrillo"
				:madrillaController="true"
				:padrillo="padrilloSelected"
				@hidden="openModalPosturaPadrillo = false"
				@refresh="handleRefresh"
			/>

			<AssignMadrillasModal
				:show="assignMadrillas.show"
				:info="assignMadrillas.info"
				@closing="assignMadrillas.show = false"
				@refresh="fetchSpecimensWithoutPostures"
			/>
			<PadrilloAvailableTracking
				:show="padrilloAvailable.show"
				:info="padrilloAvailable.info"
				@closing="padrilloAvailable.show = false"
			/>
		</b-modal>
	</div>
</template>

<script>
import EncasteService from "@/services/encaste.service"
import specimenService from "@/services/specimens.service"
import SpecimenPlate from "@/components/specimens/SpecimenPlate.vue"
import MadrillasWithInseminationPending from "@/views/amg/encaste/posturas/modals/MadrillasWithInseminationPending.vue"
import AssignMadrillasModal from "./AssignMadrillasModal.vue"
import PadrilloAvailableTracking from "./PadrilloAvailableTracking.vue"
import AddPosturaWithPadrillo from "@/views/amg/encaste/posturas/modals/AddPosturaWithPadrillo.vue"
import PeriodDays from "@/components/specimens/posture-periods/PeriodDays.vue"
export default {
	components: {
		SpecimenPlate,
		MadrillasWithInseminationPending,
		AddPosturaWithPadrillo,
		AssignMadrillasModal,
		PadrilloAvailableTracking,
		PeriodDays,
	},
	props: {
		show: Boolean,
		info: Object,
		counters: {
			type: Object,
			default: () => ({
				programados: 0,
				no_programados: 0,
				availables: 0,
			}),
		},
	},
	data() {
		return {
			isActive: false,
			isLoading: false,
			indexTab: 0,
			indexSubTab: 0,
			specimens: [],
			infoPadrillo: null,
			showMadrillasModal: false,
			padrilloSelected: null,
			// Dispuestos
			postures: [
				{
					specimen: {},
				},
			],
			dispuestosLoading: true,
			currentPage: 1,
			from: null,
			total: null,
			to: null,
			perpage: null,
			searchFilter: null,
			assignMadrillas: { show: false, info: {} },
			padrilloAvailable: { show: false, info: {} },
			openModalPosturaPadrillo: false,
		}
	},
	methods: {
		showModalMadrillas(padrillo) {
			this.infoPadrillo = padrillo
			this.showMadrillasModal = true
		},
		handleHidden() {
			this.isActive = false
			this.isLoading = false
			this.$emit("closing")
		},
		getTooltipContent(madrillas) {
			return `<ul style="margin: 0; padding-left: 1rem">${madrillas
				.map(
					(madrilla) =>
						`<li>${madrilla.alias ? `${madrilla.alias} / (${madrilla.plate})` : `(${madrilla.plate})`}</li>`
				)
				.join("")}</ul>`
		},
		openModalPosturaPad(item) {
			this.padrilloSelected = item
			this.openModalPosturaPadrillo = true
		},
		async getSpecimens() {
			this.isPreloading()
			try {
				const { data } = await EncasteService.getSpecimensAvailables({
					tab_id: this.indexTab === 0 ? 1 : 2,
					insemination: this.indexSubTab === 0 ? 1 : 2,
				})
				this.specimens = data
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
		handleRefresh() {
			if (this.indexTab === 2) {
				this.fetchSpecimensWithoutPostures()
			}
			this.$emit("refresh")
		},
		async fetchSpecimensWithoutPostures() {
			this.dispuestosLoading = true
			const { data } = await specimenService.getRestingPadrillos({
				page: this.currentPage,
				perpage: 20,
				search: this.searchFilter,
			})
			this.currentPage = data.current_page
			this.from = data.from
			this.total = data.total
			this.to = data.to
			this.postures = data.data.map((it) => {
				return {
					...it,
					eggs_in_the_air: it.eggs_in_the_air || 0,
				}
			})
			this.dispuestosLoading = false
		},
		clearFilters() {
			this.searchFilter = ""
			this.fetchSpecimensWithoutPostures()
		},
		handleCreateNewPosture(specimen) {
			this.assignMadrillas.info = specimen
			this.assignMadrillas.show = !this.assignMadrillas.show
		},
	},
	watch: {
		indexTab: async function (newValue, oldValue) {
			if (newValue === 2) {
				await this.fetchSpecimensWithoutPostures()
			} else {
				await this.getSpecimens()
			}
		},
		indexSubTab: async function () {
			await this.getSpecimens()
		},
	},
	async mounted() {
		await this.getSpecimens()
		this.$refs["padrillos-posture-modal"].toggle()
	},
}
</script>

<style scoped>
.card-body {
	padding: 1rem !important;
}
</style>
